<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="dealerselect" :widthLeft="item.widthLeft" :widthRight="item.widthRight"
						:options="item.options" :lablewith="item.lablewith" :loading="loading"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" @change1="change1" @change2="change2" @remoteMethodtows="remoteMethodtows"
						@hospitalChange="hospitalChange">
					</Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :qhide="false" :show="showorhide" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>

			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Dealerhospitalmaintenanceindicatorstable :tableData="tableData" :total="total" @Import="Import"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Dealerhospitalmaintenanceindicatorstable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import utils from '../../../common/utils'
	import Dealerhospitalmaintenanceindicatorstable from './components/dealerhospitalmaintenanceindicatorstable.vue'
	import {
		CustomerQuotaList,
		CustomerQuotaExport,
		InventoryClassList,
		HospitalList,
		ASNVoucherType,
		HelperTechnicalOfficesList
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			Dealerhospitalmaintenanceindicatorstable,
			Dialog,
			CommonBtngroup
		},
		data() {
			return {
				dialogVisibles: false,
				showorhide: true,
				loading: true,
				total: 1,
				pageindex: 1,
				pageSize: 20,
				from: {
					quotaType: "",
					cusName: "",
					hospital: "",
					TechnicalOfficesID: "",
					status: "",
					priceColName: "",
					invClass: "",
					year: "",
					createTime1: "",
					createTime2: "",
				},
				tableData: [],
				formdata: [{
						inputdata: "",
						title: '指标类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '225px',
						btx: true,
						lablewith: '100px',
						options: [{
							key: '1',
							value: '采购指标'
						}, {
							key: '0',
							value: '销售指标'
						}, ]
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '225px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '225px',
						btx: true,
						// lablewith: '90px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'selectautocompletes',
						width: '225px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '科室',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '225px',
						lablewith: '100px',
						options: [{
							key: '',
							value: '全部'
						}]
					},

					{
						inputdata: '',
						title: '年度',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '225px',
						btx: true,
						lablewith: '100px',
						options: [

						]
					},
					{
						inputdata: "",
						title: "创建日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "dateSection",
						widthLeft: 235,
						widthRight: 280,
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '业务员',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '215px',
						lablewith: '100px'
					}
				]
			}
		},
		created() {

		},
		computed: {
			// 获取去年-今年-明年
			Year() {
				let date = new Date()
				let yearStr = `${date.getFullYear() - 1}-${date.getFullYear()}-${date.getFullYear() + 1}`
				let yearArr = [{
						key: date.getFullYear() - 1,
						value: date.getFullYear() - 1,
					},
					{
						key: date.getFullYear(),
						value: date.getFullYear(),
					},
					{
						key: date.getFullYear() + 1,
						value: date.getFullYear() + 1,
					},
				]
				return yearArr
			},
		},
		mounted() {
			this.$refs.dealerselect[0].modelvalue = this.$refs.dealerselect[0].options[0].key
			this.from.quotaType = this.$refs.dealerselect[0].modelvalue
			//console.log(this.Year, 'this.Year');
			this.formdata[5].options = this.Year
			this.customerQuotaList()
			this.inventoryClassList()
		},
		methods: {
			async customerQuotaList() {
				const loading = this.$loading({
					lock: true,
					text: '加载列表中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await CustomerQuotaList({
					quotaType: this.from.quotaType,
					cusName: this.from.cusName,
					hospital: this.from.hospital,
					TechnicalOfficesID: this.from.TechnicalOfficesID,
					status: this.from.status,
					priceColName: this.from.priceColName,
					invClass: this.from.invClass,
					year: this.from.year,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					SalesMan: this.from.SalesMan,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
				loading.close();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[2].options = []
					let obj2 = {
						key: "",
						value: "全部"
					}
					this.formdata[2].options.push(obj2)
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[2].options.push(obj)
					})

				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdata[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[6].options.push(obj)
					})
				}
			},
			// 医院下拉

			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await HospitalList({
					pageSize: 50,
					pageIndex: 1,
					hpName: query
				})
				if (code == 0) {
					this.formdata[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdata[3].options.push(obj)

					})
					this.loading = false
				}
			},
			async loadTechnicalOfficesOptions(hospitalId) {
				this.formdata[4].options = [{
					key: '',
					value: '全部'
				}]
				if (!hospitalId) {
					return
				}
				let {
					code,
					data
				} = await HelperTechnicalOfficesList({
					Hospital: Number(hospitalId)
				})
				if (code == 0) {
					const list = Array.isArray(data) ? data : []
					list.map((item) => {
						this.formdata[4].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			async hospitalChange(e) {
				const hospitalId = e.modelvalue
				if (this.$refs.dealerselect && this.$refs.dealerselect[4]) {
					this.$refs.dealerselect[4].modelvalue = ''
				}
				this.from.TechnicalOfficesID = ''
				await this.loadTechnicalOfficesOptions(hospitalId)
			},
			// 导出
			async customerQuotaExport() {
				let resexprot = await CustomerQuotaExport({
					quotaType: this.from.quotaType || this.$refs.dealerselect[0].options[0].key,
					cusName: this.from.cusName,
					hospital: this.from.hospital,
					TechnicalOfficesID: this.from.TechnicalOfficesID,
					status: this.from.status,
					priceColName: this.from.priceColName,
					invClass: this.from.invClass,
					year: this.from.year,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					SalesMan: this.from.SalesMan,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `客户医院指标${str}`, "xlsx")
					this.customerQuotaList()
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			// 导出
			Import() {
				this.customerQuotaExport()
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.customerQuotaList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.customerQuotaList()

			},
			reset() {
				this.$refs.dealerselect.forEach((item, index) => {
					if (index == 6) {
						item.startTime = ''
						item.endTime = ''
					} else {
						item.modelvalue = ''
					}
				})
				this.formdata[4].options = [{
					key: '',
					value: '全部'
				}]
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			hide() {
				this.showorhide = false

			},
			select() {
				this.pageindex = 1
				try {
					this.from.quotaType = this.$refs.dealerselect[0].modelvalue
					this.from.cusName = this.$refs.dealerselect[1].modelvalue
					this.from.hospital = this.$refs.dealerselect[3].modelvalue
					this.from.TechnicalOfficesID = this.$refs.dealerselect[4].modelvalue
					// this.from.status = this.$refs.dealerselect[6].modelvalue
					// this.from.priceColName = this.$refs.dealerselect[7].modelvalue 
					this.from.createTime1 = this.$refs.dealerselect[6].endTime
					this.from.createTime2 = this.$refs.dealerselect[6].startTime
					this.from.invClass = this.$refs.dealerselect[2].modelvalue
					this.from.year = this.$refs.dealerselect[5].modelvalue
					this.from.SalesMan = this.$refs.dealerselect[7].modelvalue
					this.customerQuotaList()
				} catch (error) {
					this.customerQuotaList()
				}
			},
			showclick() {
				this.showorhide = true
			},
			change1(val) {
				//console.log(val)
				this.createTime1 = val
			},
			change2(val) {
				//console.log(val)
				this.createTime2 = val
			}
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 105px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all .3s;
		overflow: hidden;
		position: relative;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 20px;
		width: 349px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 46px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 30px;
	}
</style>
